import { useState, useEffect, useRef } from "react";
import { FaArrowUp } from "react-icons/fa";
import "../styles/BackToTop.css";

const IDLE_TIMEOUT = 5000; // 5 seconds

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const idleTimer = useRef(null);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const handleUserActivity = () => {
    setIsActive(true);
    if (idleTimer.current) clearTimeout(idleTimer.current);
    idleTimer.current = setTimeout(() => {
      setIsActive(false);
    }, IDLE_TIMEOUT);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("scroll", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);
    // Start idle timer on mount
    handleUserActivity();
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("scroll", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
      if (idleTimer.current) clearTimeout(idleTimer.current);
    };
  }, []);

  return (
    <div
      className={`back-to-top ${isVisible && isActive ? "visible" : ""}`}
      onClick={scrollToTop}
    >
      <FaArrowUp className="back-to-top-icon" />
    </div>
  );
};

export default BackToTop;
